import React from 'react'

export const AddNewItem = ({ open, title, onChangeTitle, placeholder, onSave, onCancel, error = false }) => {
    if (open)
        return (
            <>
                <li className={`newPageLI ${error ? "addnewitem-error" : ""}`}>
                    <input
                        onKeyDown={(e) => { if (e.key == "Enter") onSave() }}
                        value={title}
                        onChange={onChangeTitle}
                        type="text"
                        placeholder={placeholder}
                        className="new"
                    />
                    <i onClick={onSave} className="fas fa-plus" />
                    <i onClick={onCancel}
                        className="fas fa-times"
                    ></i>

                </li>
                {error.length > 0 && <p style={{fontSize: "11px", color: "red"}}>{error}</p> }
            </>
        )
}

export const EditItem = ({ open, title, onChangeTitle, itemIndex, onSave, onCancel }) => {
    if (open)
        return (
            <div className="editNav">
                <li
                    style={
                        title.length == 0
                            ? { borderColor: "red" }
                            : { marginTop: `${55 * itemIndex}px` }
                    }
                    className="confirmOrCancel"
                >
                    <input
                        onKeyDown={(e) => { if (e.key == "Enter") onSave() }}
                        onChange={onChangeTitle}
                        type="text"
                        value={title}
                        className="new"
                        style={title.length == 0 ? { borderColor: "red" } : {}}
                    />
                    <i onClick={onSave} className="fas fa-check" />
                    <i onClick={onCancel} className="fas fa-times" />
                </li>
            </div>
        )
}